import { Action, BasketballAction } from "../types";
import { isBasketballAction } from "./frame-stencil-controller";

export const isClassicEndPoint = (action: Action): action is BasketballAction =>
  isBasketballAction(action) &&
  !!action?.classicEndPoint &&
  action?.classicEndPoint?.x !== action.endPos.x &&
  action?.classicEndPoint?.y !== action.endPos.y;

export const clearClassicEndPoint = (action: Action): Action => {
  if (isBasketballAction(action)) {
    const { classicEndPoint: _classicEndPoint, ...restAction } = action;
    return restAction;
  } else return action;
};
